import { Palette } from 'config';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  color: ${Palette.PrimaryGray._500};
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-right: none;
  border-radius: 4px 0px 0px 4px;
`;
